export default "__VITE_ASSET__dgmDrh1c__"